// @flow

// Utils
import traverse from 'fc-utils/traverse'

// Constants
import {
  TREE,
  IS_LOADING,
} from '../constants'

export default traverse([TREE, IS_LOADING], {default: {}})
